import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/value-proposition.png";
import { Helmet } from "react-helmet";

class ValueProposition extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Value Proposition | Why Enterprises Modernize With Avani Cimcon</title>
          <meta
            name="keywords"
            content="value proposition, enterprise modernization, modernization rather than replacement, AI enablement, proprietary SOA, service-oriented architecture, offshore development, enterprise software engineering, client accepted solutions"
          />
          <meta
            name="description"
            content="Avani Cimcon's value proposition connects decades of engineering experience with modernization, AI enablement, and long-term enterprise ownership."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/value-proposition" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Value Proposition</h1>
            <h5>Why modernization works better when it builds on existing investments</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p>
                Enterprises choose Avani Cimcon when they want modernization that respects what
                already exists. The company has learned over decades that the best transformation
                programs do not start by discarding working systems. They start by understanding
                them.
              </p>
              <p>
                That is why the value proposition is centered on practical enterprise outcomes:
                lower delivery risk, clearer ownership, safer modernization, and AI that extends
                existing investment instead of replacing it without a plan.
              </p>

              <ul className="list-unstyled p-0 m-0">
                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Modernization that builds on existing enterprise investment
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Modular and configurable solutions customized for industry verticals like Travel
                    and BFSI
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Solutions built on proprietary SOA that has been developed ground-up
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Applications designed around the solution create additional operational value
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Solutions already deployed and client-accepted
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Experience in the verticals helps buyers move faster with lower risk
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Proven execution capabilities with a strong technology and delivery focus
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Ongoing investments in solution upgradation and applied research
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Quality focus grounded in ISO discipline and enterprise delivery controls
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Engineering-led systems that can evolve with the enterprise
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Process-driven delivery mechanisms that stay effective at scale
                  </div>
                </li>

                <li className="mb-3">
                  <div className="d-flex shadow-sm p-2 rounded align-items-center">
                    <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                    Offshore development, support, and implementation that keep programs cost
                    effective
                  </div>
                </li>
              </ul>

              <div className="shadow-sm p-3 mt-4">
                <h4 className="text-primary mb-3 font-weight-bold">How this connects to the homepage story</h4>
                <p>
                  The homepage says what the company does. The value proposition explains why that
                  matters commercially: it helps enterprises modernize mission-critical software,
                  keep long-lived platforms viable, and adopt AI in a controlled way.
                </p>
                <p className="mb-0">
                  That logic is reinforced by <Link to="/it-consulting-services">Solutions</Link>,
                  <Link to="/expertise-experience">enterprise experience</Link>, and the
                  <Link to="/contact-us">Contact</Link> path for qualified modernization
                  discussions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ValueProposition;
